import ET3Div from "../../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../../core/et3-text";

const UserDetailRow = withLiteObserverAndTheme<{ title: any; value: any }>(
  (props) => {
    const { title, value, theme } = props;
    const { colors } = theme;

    return (
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        color={colors.all.transparent}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-end"
        withShadow={false}
        width={650}
        height={0}
        style={{
          fontSize: 16
        }}
        onClick={() => {}}
      >
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          color={colors.all.transparent}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={250}
          height={50}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"BOLD"}
            fontSize={18}
            text={`${title}: `}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
        </ET3Div>
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          color={colors.all.transparent}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={300}
          height={50}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={value}
            isSpan={false}
            color={colors.all.black}
            style={{}}
          />
        </ET3Div>
      </ET3Div>
    );
  }
);
export default UserDetailRow;
